import { css } from 'styled-components';
/**
 * Source: https://cloudfour.com/thinks/see-no-evil-hidden-content-and-accessibility/
 *
 * Important: Don't use this helper for interactive elements as this snippet
 * moves elements out of the viewport. This is intended for hidden text but in
 * the case of interactive elements, touchscreen users can no longer interact
 * with an element this is applied to.
 *
 * If the intention is to hide a native control (e.g. checkbox, radio button,
 * file upload button, ...), try to use an invisible (opacity: 0) element with
 * the same height/width as the replacement. See https://www.sarasoueidan.com/blog/inclusively-hiding-and-styling-checkboxes-and-radio-buttons/
 * for details.
 */
export const AssistiveTechnologyOnly = css `
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: polygon(0px 0px, 0px 0px, 0px 0px);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  white-space: nowrap;
`;
